import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme, Typography } from '@material-ui/core'
import React from 'react'
import SharedAIDisclaimerDialog from 'components/AIDisclaimerDialog'

interface AIDisclaimerDialogProps {
    open: boolean
    onClose: () => void
}

const useStyles = makeStyles((theme: Theme) => ({
    text: {
        color: '#304959',
        fontSize: pxToRem(14),
        lineHeight: pxToRem(20),
        marginBottom: theme.spacing(2),
        '&:last-child': {
            marginBottom: 0,
        },
    },
    bold: {
        fontWeight: 600,
    },
}))

export const AIDisclaimerDialog = ({ open, onClose }: AIDisclaimerDialogProps) => {
    const classes = useStyles()
    return (
        <SharedAIDisclaimerDialog open={open} onClose={onClose}>
            <Typography className={classes.text}>
                Customer's version of Specpoint BPM includes building Product Listings containing manufacturer data
                extracted and structured using artificial intelligence from publicly available sources and combined with
                proprietary Deltek data. Deltek does not independently verify the accuracy of product information. Customer acknowledges that
                product information may contain inaccuracies or errors and that Customer is responsible for independently
                reviewing and verifying its accuracy. THE PRODUCT LISTINGS ARE PROVIDED STRICTLY ON AN "AS IS," "AS
                AVAILABLE" BASIS, AND CUSTOMER'S USE IS AT CUSTOMER'S SOLE RISK. Deltek does not use customer-provided
                project data to train AI features.
            </Typography>
            <Typography className={classes.text}>
                <span className={classes.bold}>Disclaimer:</span> Product Listings contain manufacturer data
                extracted and structured by artificial intelligence from publicly available sources and proprietary Deltek
                data. Deltek does not independently verify accuracy. Users should independently review and verify all
                information. Product names, trademarks, and specifications are property of their respective manufacturers.
                © 2026 Deltek, Inc.
            </Typography>
        </SharedAIDisclaimerDialog>
    )
}

export default AIDisclaimerDialog
